import PhDUploadFormModel from "./PhDUploadFormModel";
const {
  formField: {
    // info
    statementReportGuideline,
    //info
    /////////////////Page1Form 3Year///////////////////////////
    yourProgramType,
    sendingScholarshipReport,
    semester,
    /////////////////Page1Form 3Year///////////////////////////

    /////////////////Page2Form 2A/////////////////////////////
    receivingScholarship,
    reportNo,
    previousSemester,
    inputList,
    receivedGradeReportGpa,
    thesisCreditsProgram,
    currentTotalThesisCredits,
    remainingThesisCreditsProgram,
    gpa,
    gpax,
    currentTotalCredits,
    remainingCreditsProgram,
    researchTitleSelect,
    mainResearchArea,
    researchTitle,
    /////////////////Page2Form 2A/////////////////////////////

    /////////////////Page3Form 2B/////////////////////////////
    startWritingResearchProposal,
    uploadCurrentResearchProposal,
    qualifyingExamResult,
    whenQualifyingExamination,
    proposalExaminationResult,
    whenProposalExamination,
    presentProgressResearchProject,
    subjectAreaPublished,
    manuscriptPublication,
    manuscriptId,
    journalRanking,
    conductingResearchAbroad6Months,
    answerPlaning,
    answerCountryPlan,
    highPerformanceProfessor,
    professorCollaboratorName,
    instituteProfessorCollaborator,
    /////////////////Page3Form 2B/////////////////////////////

    /////////////////Page2Form 2C/////////////////////////////
    yourResearchField,
    presentProgressResearchProject2c,
    articleTitle,
    manuscriptId2c,
    typeManuscript,
    journal,
    subjectAreaCategory,
    journalRanking2c,
    authors,
    uploadResearchPublication,
    receivedDate,
    revisedDate,
    acceptedDate,
    publishedDate
    /////////////////Page2Form 2C/////////////////////////////
  }
} = PhDUploadFormModel;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // info
  [statementReportGuideline.name]: "",
  //info

  /////////////////Page1Form 3Year///////////////////////////
  [yourProgramType.name]: "",
  [sendingScholarshipReport.name]: "",
  [semester.name]: "",
  /////////////////Page1Form 3Year///////////////////////////

  /////////////////Page2Form 2A/////////////////////////////
  [receivingScholarship.name]: "",
  [reportNo.name]: "",
  [previousSemester.name]: "",
  [inputList.name]: [
    {
      [inputList.subMenu[0].subjectCourseNo.name]: "",
      [inputList.subMenu[0].courseTitle.name]: "",
      [inputList.subMenu[0].credit.name]: "",
      [inputList.subMenu[0].grade.name]: ""
    }
  ],
  [receivedGradeReportGpa.name]: "",
  [thesisCreditsProgram.name]: "",
  [currentTotalThesisCredits.name]: "",
  [remainingThesisCreditsProgram.name]: "",
  [gpa.name]: "",
  [gpax.name]: "",
  [currentTotalCredits.name]: "",
  [remainingCreditsProgram.name]: "",
  [researchTitleSelect.name]: "",
  [mainResearchArea.name]: "",
  [researchTitle.name]: "",
  /////////////////Page2Form 2A/////////////////////////////

  /////////////////Page3Form 2B/////////////////////////////
  [startWritingResearchProposal.name]: "",
  [uploadCurrentResearchProposal.name]: null,
  [qualifyingExamResult.name]: "",
  [whenQualifyingExamination.name]: "",
  [proposalExaminationResult.name]: "",
  [whenProposalExamination.name]: "",
  [presentProgressResearchProject.name]: "",
  [subjectAreaPublished.name]: "",
  [manuscriptPublication.name]: null,
  [manuscriptId.name]: "",
  [journalRanking.name]: "",
  [conductingResearchAbroad6Months.name]: "",
  [answerPlaning.name]: "",
  [answerCountryPlan.name]: "",
  [highPerformanceProfessor.name]: "",
  [professorCollaboratorName.name]: "",
  [instituteProfessorCollaborator.name]: "",
  /////////////////Page3Form 2B/////////////////////////////

  /////////////////Page2Form 2C/////////////////////////////
  [yourResearchField.name]: "",
  [presentProgressResearchProject2c.name]: "",
  [articleTitle.name]: "",
  [manuscriptId2c.name]: "",
  [typeManuscript.name]: "",
  [journal.name]: "",
  [subjectAreaCategory.name]: "",
  [journalRanking2c.name]: "",
  [authors.name]: "",
  [uploadResearchPublication.name]: null,
  [receivedDate.name]: "",
  [revisedDate.name]: "",
  [acceptedDate.name]: "",
  [publishedDate.name]: ""
  /////////////////Page2Form 2C/////////////////////////////
};
